import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoaderService {
    public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    display(value: boolean) {
        this.status.next(value);
    }
}


// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/services/loader.service.ts